/** 与 chat.images 列表项 key 保持一致，用于定位预览起始图 */
export function buildGalleryImageKey(input: {
  message_id: string
  attach_path?: string | null
  url?: string | null
  content?: string | null
}): string {
  return `${input.message_id}-${input.attach_path || input.url || input.content || ""}`
}

export function findGalleryImageIndex(
  images: { key: string; message_id?: string; attach_path?: string | null; url?: string | null; content?: string | null }[],
  input: Parameters<typeof buildGalleryImageKey>[0],
): number {
  const key = buildGalleryImageKey(input)
  const byKey = images.findIndex((img) => img.key === key)
  if (byKey >= 0) return byKey

  if (input.message_id) {
    const byMessageId = images.findIndex((img) => img.message_id === input.message_id)
    if (byMessageId >= 0) return byMessageId
  }

  return -1
}

export function findGalleryImageIndexByKey(images: { key: string }[], imageKey?: string | null): number {
  if (!imageKey) return -1
  return images.findIndex((img) => img.key === imageKey)
}

/** 画廊列表按 key 去重（兜底） */
export function dedupeGalleryImages<T extends { key: string }>(images: T[]): T[] {
  const seen = new Set<string>()
  return images.filter((img) => {
    if (!img.key || seen.has(img.key)) return false
    seen.add(img.key)
    return true
  })
}
